import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ProjectService } from 'src/app/_services/project.service';
import { UserMgmtService } from 'src/app/_services/user-mgmt.service';
import { UserService } from 'src/app/_services/user.service';
import { WorkflowService } from 'src/app/_services/workflow.service';
import { beatBlipSubscriptionConsts } from 'src/app/consts/beatBlipSubscriptionConsts';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-wf-template',
  templateUrl: './wf-template.component.html',
  styleUrls: ['./wf-template.component.scss']
})
export class WfTemplateComponent implements OnInit {
pagesSize = beatBlipSubscriptionConsts.pagesSize;
  perpageitem = beatBlipSubscriptionConsts.perpageitem;
  selectedPage: any;
  searchString: any;
  groupListCopy: any;
  workFlowList: any;
  workFlowListCopy: any;
  selectedUserId: any;
  masterUsers: any = [];
  customerList:any = [];
  userList: any = [];
  selectedWorkflow: any;
  filterFlags = {
    name: false,
    date: false,
    active: 'name'
  };
  startedWorflowId: string = ''
  

  @Output() startEvent = new EventEmitter<string>();

  constructor(
    private project: ProjectService,
    private userManagement: UserMgmtService,
    private userService: UserService,
    private workflowService: WorkflowService,
    private toastrService: ToastrService
  ) { }

  ngOnInit(): void {

    this.loadCurrentUser();
    this.loadUsers();
  }

  onPageChange(newValue) {
    this.selectedPage = newValue;
    this.perpageitem = newValue;
  }

  filterGroup()
  {
    console.log("text ",this.searchString);

    let wfCopy = JSON.parse(JSON.stringify(this.workFlowList));
    if(wfCopy.length == 0)
    {
      return;
    }
   this.workFlowList =  wfCopy.filter(wf => {
        let wfname =  wf.name.toLowerCase();
        if(wfname.includes(this.searchString.toLowerCase()))
        {
          return true;
        }
    });



  }
  sortColumn: string = 'updatedDate';
  // sortColumn1: string = 'updatedAt';
  sortDirection: 'asc' | 'desc' = 'asc';

  sortData(column: string) {

    console.log(this.workFlowList);

    if (this.sortColumn != column) {
      this.sortDirection = 'asc'
    }
    this.sortDirection = this.sortColumn === column && this.sortDirection === 'asc' ? 'desc' : 'asc';
    this.sortColumn = column;
    this.sortDirection === 'asc' ? document.getElementById("sortCol").className = "asc" : document.getElementById("sortCol").className = "desc";

    const getColumnValue = (item: any, column: string) => {
      // Check if column exists inside 'workflow' object
      return item.workflow && item.workflow[column] !== undefined ? item.workflow[column] : null;
    };
    
    this.workFlowList.sort((a, b) => {
      const valueA = getColumnValue(a, column);
      const valueB = getColumnValue(b, column);

      // Handle null or undefined values
      if (valueA === null || valueA === undefined) return this.sortDirection === 'asc' ? -1 : 1;
      if (valueB === null || valueB === undefined) return this.sortDirection === 'asc' ? 1 : -1;

      if (typeof valueA === 'string' && typeof valueB === 'string') {
        return this.sortDirection === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
      }

      if (valueA instanceof Date && valueB instanceof Date) {
        return this.sortDirection === 'asc' ? +valueA - +valueB : +valueB - +valueA;
      }

      return 0;
    });
  }

  sortTemplates(type)
  {
    const parseDate = (str: string) => {
      if (!str) return 0;
  
      const match = str.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2})(\d{2})(\d{2})$/);
      if (!match) return 0;
  
      const [_, year, month, day, hour, minute, second] = match;
      return new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}Z`).getTime();
    };

    switch (type) {
      case 'name':
        if (this.filterFlags.name) {
          this.workFlowList = [...this.workFlowListCopy].sort((a, b) => a.workflow.name.localeCompare(b.workflow.name));
        }
        else {
          this.workFlowList = [...this.workFlowListCopy].sort((a, b) => a.workflow.name.localeCompare(b.workflow.name)).reverse();
        }
        this.filterFlags.active = 'name';
        this.filterFlags.name = !this.filterFlags.name
        this.filterFlags.date = false;
        break;

      case 'updatedDate':
        if (this.filterFlags.date) {
          this.workFlowList = [...this.workFlowListCopy].sort((a, b) => parseDate(a.workflow.updatedDate) - parseDate(b.workflow.updatedDate));
        }
        else {
          this.workFlowList = [...this.workFlowListCopy].sort((a, b) => parseDate(a.workflow.updatedDate) - parseDate(b.workflow.updatedDate)).reverse();
        }
        this.filterFlags.active = 'updatedDate';
        this.filterFlags.date = !this.filterFlags.date;
        this.filterFlags.name = false;
        break;

      case 'All':
        this.workFlowList = JSON.parse(JSON.stringify(this.workFlowListCopy));
        this.filterFlags.active = '';
        this.filterFlags.name = false;
        this.filterFlags.date = false;
        break;

      case 'Published':
        this.workFlowList = JSON.parse(JSON.stringify(this.workFlowListCopy.filter((item: any) => item.workflow.status == 'Publish')))
        this.filterFlags.active = '';
        this.filterFlags.name = false;
        this.filterFlags.date = false;
        break;

      case 'Draft':
        this.workFlowList = JSON.parse(JSON.stringify(this.workFlowListCopy.filter((item: any) => item.workflow.status == 'Draft')))
        this.filterFlags.active = '';
        this.filterFlags.name = false;
        this.filterFlags.date = false;
        break;

      case 'view':
        this.workFlowList = JSON.parse(JSON.stringify(this.workFlowListCopy.filter((item: any) => item?.workflowUserRestriction?.view))) 
        this.filterFlags.active = '';
        this.filterFlags.name = false;
        this.filterFlags.date = false;
        break;

      case 'edit':
        this.workFlowList = JSON.parse(JSON.stringify( this.workFlowListCopy.filter((item: any) => item?.workflowUserRestriction?.execute)))
        this.filterFlags.active = '';
        this.filterFlags.name = false;
        this.filterFlags.date = false;
        break;
    }

  }

  searchTemplate()
  {
   let  searchText = this.searchString.toLowerCase();

    this.workFlowList = this.workFlowListCopy.filter(it => {
      return it.workflow.name.toLowerCase().includes(searchText);
    });
  }

loadWfList(){
  let currentUser = JSON.parse(localStorage.getItem('currentUser'));
  this.project.getTempList(currentUser.id).subscribe(
    (res:any)=>{
      this.workFlowList = res
      this.workFlowListCopy =  JSON.parse(JSON.stringify(this.workFlowList));
      console.log('templist',this.workFlowList);
      this.sortTemplates('updatedDate');
      // this.loadwfRestriction(currentUser)
    }
  )
}

loadwfRestriction(selectedUser){
  this.selectedUserId = selectedUser.id;

  this.project.getPermissionWorkFlow().subscribe((response:any)=>
    {
      console.log('response',response);
    var restrictedWf = response.filter((f:any)=>f.userId==this.selectedUserId)
    console.log('test1',restrictedWf);
    
      // this.oldUser = false;
      if(response)
      {
        restrictedWf.forEach(element => {
              this.workFlowList.forEach(data => {
                  if(element.workflowId== data.id)
                  {
                    data['view'] =element['view'];
                    data['edit'] = element['edit'];
                    data['disabled'] = element['disabled'];
                    data['execute'] = element['execute'];
                    data['workflowId'] = element['workflowId']
                    
                    
                  }
              });
              console.log('testWF',this.workFlowList);
              
          });

          this.workFlowListCopy =  JSON.parse(JSON.stringify(this.workFlowList));
         // check if multiSelect is on or not 
      }
     
    
    }) 
}

getUserName(userId: string)
{
  let userName = '';
  if(!userId)
  {
    userName = 'unknown';
  }
  else
  {
    this.userList.forEach((user: any) => {
        if(user.userId == userId)
        {
          userName = user.sharedName;
        }
    });
  }
  return userName;
} 

loadCurrentUser()
{
  this.userService.getUser().subscribe((res)=>
  {
    localStorage.setItem('currentUser', JSON.stringify(res));
    this.loadWfList();
  })
}

loadUsers() {

  this.userList = [];
  this.userManagement.loadActiveUsers().subscribe((response: any)=>
  {
    if(response.length > 0)
    {
      response.forEach( u => {
        this.userList.push({ userId: u.id, sharedName: u.name });
      });
    }
  })
}


selectedWorkflowToExecute(temp){
  this.startEvent.emit(temp);
}

highLightWorkflow(id)
{
  this.startedWorflowId = id;

  this.workFlowListCopy.forEach(element => {
    if(element.workflow && element.workflow.id == id)
    {
      element.intances = element.intances + 1;
    }
  });
  setTimeout(()=>
    {
      this.startedWorflowId = '';
    }, 5000)
}

//temp?.workflow?.status=='Publish' && temp?.workflowUserRestriction?.execute ||
enableExecuteButton(workflow:any){
  if(workflow?.workflow?.status=='Publish' && workflow?.workflowUserRestriction?.execute){
    return true;
  }
  else if(workflow?.workflow?.latestPublish && workflow?.workflowUserRestriction?.execute){
    return true;
  }
  else if(workflow?.workflow?.status=='Draft' && workflow?.workflow?.latestPublish && workflow?.workflowUserRestriction?.execute){
    return true;
  }
  else{
    return false;
  }
}

}
